var _linearGradient, _path, _linearGradient2, _path2, _path3, _linearGradient3, _path4, _path5, _linearGradient4, _path6, _path7, _linearGradient5, _path8, _linearGradient6, _path9, _linearGradient7, _path10, _linearGradient8, _path11, _linearGradient9, _path12, _linearGradient10, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 43.068,
    y1: 57.798,
    x2: 40.068,
    y2: 64.298
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff3d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#ffcc60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbc31"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 59.3l-4.2 4.2c2.4 2.7 6.5 2.8 9.1.3.8-.9.3-2.3-.9-2.5-1.5-.2-3-.9-4-2z",
    fill: "url(#A)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 31.138,
    y1: 70.918,
    x2: 49.108,
    y2: 70.918
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#f5f4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efecf3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4 61.8L48 72.4a4.41 4.41 0 0 1 0 6.2 4.41 4.41 0 0 1-6.2 0L31.2 68.1l6.2-6.3z",
    fill: "url(#B)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 68.1l.6.6c1.6 1.6 4.2 1.6 5.9 0l.9-.9 7 7c1.3 1.3 1.6 3.2 1 4.8.5-.2 1-.5 1.4-1a4.41 4.41 0 0 0 0-6.2L37.4 61.8l-6.2 6.3z",
    opacity: 0.07,
    enableBackground: "new"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 32.78,
    y1: 30.378,
    x2: 60.012,
    y2: 30.378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff3d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#ffcc60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbc31"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4 45.1c8.1 0 14.7-6.6 14.7-14.7s-6.6-14.7-14.7-14.7-14.7 6.6-14.7 14.7 6.6 14.7 14.7 14.7z",
    fill: "url(#C)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 20.6l20.8 20.8.6-.6c2.1-2.1 3.4-4.7 4-7.4L42.4 16c-2.7.6-5.3 1.9-7.4 4-.2.2-.3.4-.5.6z",
    opacity: 0.05,
    enableBackground: "new"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 4.014,
    y1: 41.613,
    x2: 63.425,
    y2: 41.613
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#f5f4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efecf3"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 29.6h0L9.6 40.2a18.35 18.35 0 0 0 0 26 18.35 18.35 0 0 0 26 0l10.6-10.6a18.31 18.31 0 0 1 15.4-5l2.6-2.6-36.4-36.4-2.6 2.6a18.31 18.31 0 0 1-5 15.4z",
    fill: "url(#D)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8 11.6L64.2 48l-2.6 2.6c-3.2-.5-6.5-.1-9.5 1.1L24 23.7c1.2-3 1.6-6.3 1.1-9.5l2.7-2.6z",
    opacity: 0.07,
    enableBackground: "new"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 4.139,
    y1: 66.005,
    x2: 13.564,
    y2: 66.005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9aa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f23c49"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 67l-2.9 2.9a4.41 4.41 0 0 1-6.2 0 4.41 4.41 0 0 1 0-6.2l2.9-2.9L15 67z",
    fill: "url(#E)"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 2.796,
    y1: 55.651,
    x2: 31.646,
    y2: 55.651
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9aa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f23c49"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2 65.7l-26-26-.6.6a18.35 18.35 0 0 0 0 26 18.35 18.35 0 0 0 26 0l.6-.6z",
    fill: "url(#F)"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    gradientUnits: "userSpaceOnUse",
    x1: 21.668,
    y1: 30.118,
    x2: 61.578,
    y2: 30.118
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9aa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f23c49"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3 50.9L24.9 15.5a4.41 4.41 0 0 1 0-6.2 4.41 4.41 0 0 1 6.2 0l35.4 35.4a4.41 4.41 0 0 1 0 6.2c-1.7 1.8-4.5 1.8-6.2 0z",
    fill: "url(#G)"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    gradientUnits: "userSpaceOnUse",
    x1: 54.351,
    y1: 11.76,
    x2: 56.962,
    y2: 11.76
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff3d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#ffcc60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbc31"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6 15c-.8 0-1.4-.6-1.4-1.4V9.9c0-.8.6-1.4 1.4-1.4s1.4.6 1.4 1.4v3.7c0 .8-.7 1.4-1.4 1.4z",
    fill: "url(#H)"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    gradientUnits: "userSpaceOnUse",
    x1: 61.265,
    y1: 20.251,
    x2: 67.272,
    y2: 20.251
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff3d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#ffcc60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbc31"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9 21.7h-3.7c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4h3.7c.8 0 1.4.6 1.4 1.4 0 .7-.6 1.4-1.4 1.4z",
    fill: "url(#I)"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    gradientUnits: "userSpaceOnUse",
    x1: 59.24,
    y1: 14.249,
    x2: 64.253,
    y2: 14.249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff3d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.624,
    stopColor: "#ffcc60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbc31"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 16.5c-.6-.6-.6-1.4 0-2l2.6-2.6c.6-.6 1.4-.6 2 0s.6 1.4 0 2l-2.6 2.6c-.6.6-1.5.6-2 0z",
    fill: "url(#J)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.399cba8b2ad0a29ad0c1572a338ff4c9.svg";
export { ForwardRef as ReactComponent };